/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TeamSettingInvitationLinkStateResource = {
    Activated: 'ACTIVATED',
    Deactivated: 'DEACTIVATED',
    DomainRecognitionNotConfigured: 'DOMAIN_RECOGNITION_NOT_CONFIGURED'
} as const;
export type TeamSettingInvitationLinkStateResource = typeof TeamSettingInvitationLinkStateResource[keyof typeof TeamSettingInvitationLinkStateResource];


export function instanceOfTeamSettingInvitationLinkStateResource(value: any): boolean {
    for (const key in TeamSettingInvitationLinkStateResource) {
        if (Object.prototype.hasOwnProperty.call(TeamSettingInvitationLinkStateResource, key)) {
            // @ts-ignore
            if (TeamSettingInvitationLinkStateResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamSettingInvitationLinkStateResourceFromJSON(json: any): TeamSettingInvitationLinkStateResource {
    return TeamSettingInvitationLinkStateResourceFromJSONTyped(json, false);
}

export function TeamSettingInvitationLinkStateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamSettingInvitationLinkStateResource {
    return json as TeamSettingInvitationLinkStateResource;
}

export function TeamSettingInvitationLinkStateResourceToJSON(value?: TeamSettingInvitationLinkStateResource | null): any {
    return value as any;
}

